import { onDatadogRumReady } from '@/lib/analytics/datadogRum'

/**
 * Report a caught error to Datadog RUM.
 *
 * This supplements the automatic `forwardErrorsToLogs` / `forwardConsoleLogs`
 * behaviour by explicitly marking errors as RUM errors, which:
 *   - appear in the RUM Error Tracking view (not just logs)
 *   - are linked to the current session replay and user context
 *   - can trigger Datadog monitors and alerts
 *
 * Use this for errors that are *caught* and would otherwise only appear as
 * `console.error()` log lines.
 *
 * @param error   The error object (or string) to report
 * @param context Optional key/value context to attach to the error
 */
export function reportErrorToDD(error: unknown, context?: Record<string, unknown>): void {
    try {
        onDatadogRumReady((datadogRum) => {
            datadogRum.addError(error instanceof Error ? error : new Error(String(error)), context)
        })
    } catch {
        // Never let error reporting itself throw
    }
}
